const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const PHONE_RE = /^[0-9+()\s.-]*$/;
const INTL_RE = /^\+[1-9]\d{7,14}$/;
export const isIntlPhone = (v) => INTL_RE.test((v || "").replace(/[\s().-]/g, ""));

// rules: { field: ["required", ["min", n], "email", "phone", "rate", "list"] }
export const validate = (values, rules) => {
  const errors = {};
  Object.entries(rules).forEach(([field, list]) => {
    const raw = values[field];
    const v = typeof raw === "string" ? raw.trim() : raw;
    for (const rule of list) {
      const [name, arg] = Array.isArray(rule) ? rule : [rule];
      if (name === "required" && (v === undefined || v === null || v === "")) { errors[field] = ["required"]; break; }
      if (name === "list" && (!Array.isArray(v) || v.length === 0)) { errors[field] = [arg || "required"]; break; }
      if (!v) continue;
      if (name === "min" && v.length < arg) { errors[field] = ["min", arg]; break; }
      if (name === "email" && !EMAIL_RE.test(v)) { errors[field] = ["email"]; break; }
      if (name === "phone" && !PHONE_RE.test(v)) { errors[field] = ["phone"]; break; }
      if (name === "intl" && !isIntlPhone(v)) { errors[field] = ["intl"]; break; }
      if (name === "rate" && (isNaN(Number(v)) || Number(v) < 20 || Number(v) > 1000)) { errors[field] = ["rate"]; break; }
    }
  });
  return errors;
};

export const errorText = (t, err) => {
  if (!err) return null;
  const [key, arg] = err;
  const msg = t.errors[key] || t.errors.generic;
  return typeof msg === "function" ? msg(arg) : msg;
};

export const splitList = (s) => s.split(",").map((x) => x.trim()).filter(Boolean);
